var _rect, _g, _path, _text;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAppIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 4,
    y: 4,
    width: 120,
    height: 120,
    rx: 12,
    fill: "#0d1117",
    stroke: "#58a6ff",
    strokeWidth: 2
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    stroke: "#58a6ff",
    strokeWidth: 3,
    strokeLinecap: "round"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M30 50V30h28l8 8v12",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M30 50h16v28H30V50z",
    fill: "#58a6ff",
    fillOpacity: 0.2
  }), /*#__PURE__*/React.createElement("text", {
    x: 38,
    y: 45,
    fontFamily: "Arial",
    fontSize: 10,
    fill: "#58a6ff"
  }, "PDF"), /*#__PURE__*/React.createElement("path", {
    d: "M64 44l8 8-8 8m0-8h16",
    fill: "none"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 64,
    cy: 52,
    r: 4,
    fill: "#0d1117",
    stroke: "#58a6ff"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 82,
    y: 30,
    width: 28,
    height: 28,
    rx: 2,
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M90 38l4 4 8-8",
    fill: "none"
  }), /*#__PURE__*/React.createElement("text", {
    x: 86,
    y: 45,
    fontFamily: "Arial",
    fontSize: 10,
    fill: "#58a6ff"
  }, "IMG"))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M40 90h48v12a6 6 0 0 1-6 6H46a6 6 0 0 1-6-6V90z",
    fill: "#58a6ff",
    fillOpacity: 0.1
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 64,
    y: 100,
    textAnchor: "middle",
    fontFamily: "Arial",
    fontSize: 12,
    fill: "#58a6ff"
  }, "TOOLS")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAppIcon);
export default __webpack_public_path__ + "static/media/appIcon.e0ef683192c86d25c011e51b38468e82.svg";
export { ForwardRef as ReactComponent };